/**
 * Admin "view as account" peek state.
 *
 * When a Prompt Security admin selects a peek account, all account-scoped API
 * calls inject `?as_account=N` (see Api.js interceptor) so the user can
 * inspect another tenant's data without changing their AccountSwitcher.
 *
 * Cleared explicitly by the picker; survives navigation while the SPA is
 * mounted (lost on full reload — admins re-pick if needed).
 */
const SET_PEEK_ACCOUNT = 'guardian/adminPeek/SET_PEEK_ACCOUNT';
const CLEAR_PEEK_ACCOUNT = 'guardian/adminPeek/CLEAR_PEEK_ACCOUNT';

export const actions = {
  setPeekAccount: (accountId, accountName) => ({
    type: SET_PEEK_ACCOUNT,
    payload: { accountId, accountName },
  }),
  clearPeekAccount: () => ({ type: CLEAR_PEEK_ACCOUNT }),
};

const initialState = {
  accountId: null,
  accountName: null,
};

export default function adminPeekReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PEEK_ACCOUNT:
      return {
        accountId: action.payload.accountId,
        accountName: action.payload.accountName,
      };
    case CLEAR_PEEK_ACCOUNT:
      return initialState;
    default:
      return state;
  }
}
